// All PHP endpoints live under /backend/api/ on the same domain in production
// (remo.alvna.com). During local frontend dev, set REACT_APP_API_BASE to
// wherever the PHP backend is reachable, e.g. http://localhost/alvna-remo/backend/api
export const API_BASE = process.env.REACT_APP_API_BASE || "/backend/api";

export const endpoints = {
  register: `${API_BASE}/register.php`,
  login: `${API_BASE}/auth/login.php`,
  forgotPassword: `${API_BASE}/auth/forgot-password.php`,
  resetPassword: `${API_BASE}/auth/reset-password.php`,
  adminLogin: `${API_BASE}/admin/login.php`,
  adminForgotPassword: `${API_BASE}/admin/forgot-password.php`,
  adminResetPassword: `${API_BASE}/admin/reset-password.php`,
  adminTenants: `${API_BASE}/admin/tenants.php`,
  adminApprove: (id) => `${API_BASE}/admin/tenant-approve.php?id=${id}`,
  adminToggleActive: (id) => `${API_BASE}/admin/tenant-toggle-active.php?id=${id}`,
  adminCaps: (id) => `${API_BASE}/admin/tenant-caps.php?id=${id}`,
  adminDelete: (id) => `${API_BASE}/admin/tenant-delete.php?id=${id}`,
  adminBulkReset: `${API_BASE}/admin/bulk-reset-password.php`,
  dashboard: `${API_BASE}/app/dashboard.php`,
  staff: `${API_BASE}/app/staff.php`,
  staffDelete: (id) => `${API_BASE}/app/staff.php?id=${id}`,
  staffToggleActive: (id) => `${API_BASE}/app/staff.php?id=${id}`,
  menuCategories: `${API_BASE}/app/menu-categories.php`,
  menuCategoryDelete: (id) => `${API_BASE}/app/menu-categories.php?id=${id}`,
  menuItems: (categoryId) => `${API_BASE}/app/menu-items.php?category_id=${categoryId}`,
  menuItemDelete: (id) => `${API_BASE}/app/menu-items.php?id=${id}`,
  tables: `${API_BASE}/app/tables.php`,
  tableDelete: (id) => `${API_BASE}/app/tables.php?id=${id}`,
  tablePosition: (id) => `${API_BASE}/app/tables.php?id=${id}`,
  reports: `${API_BASE}/app/reports.php`,
  reportsExport: `${API_BASE}/app/reports-export.php`,
  orders: `${API_BASE}/app/orders.php`,
  staffLogin: `${API_BASE}/app/staff-login.php`,
  waiterTables: `${API_BASE}/app/waiter-tables.php`,
  waiterMenu: `${API_BASE}/app/waiter-menu.php`,
  waiterOrder: `${API_BASE}/app/waiter-order.php`,
  waiterOrderDeleteItem: (itemId) => `${API_BASE}/app/waiter-order.php?item_id=${itemId}`,
  kitchenTickets: `${API_BASE}/app/kitchen-tickets.php`,
  orderItemStatus: (id) => `${API_BASE}/app/order-item-status.php?id=${id}`,
  orderClose: (orderId) => `${API_BASE}/app/order-close.php?order_id=${orderId}`,
  orderReceipt: (orderId) => `${API_BASE}/app/order-receipt.php?order_id=${orderId}`,
  orderSplits: `${API_BASE}/app/order-splits.php`,
  orderSplitsForOrder: (orderId) => `${API_BASE}/app/order-splits.php?order_id=${orderId}`,
  orderHistory: (tableId) => `${API_BASE}/app/order-history.php${tableId ? `?table_id=${tableId}` : ""}`,
  waiterTableNote: (tableId) => `${API_BASE}/app/waiter-table-note.php?table_id=${tableId}`,
  settings: `${API_BASE}/app/settings.php`,
  profile: `${API_BASE}/app/profile.php`,
  adminTenantProfile: (id) => `${API_BASE}/admin/tenant-profile.php?id=${id}`,
  adminApproveEmailChange: (id) => `${API_BASE}/admin/approve-email-change.php?id=${id}`,
  adminSendNotification: `${API_BASE}/admin/send-notification.php`,
  adminDefaultCaps: `${API_BASE}/admin/default-caps.php`,
  adminCapRequests: `${API_BASE}/admin/cap-requests.php`,
  adminApproveCapRequest: (id) => `${API_BASE}/admin/approve-cap-request.php?id=${id}`,
  adminDeclineCapRequest: (id) => `${API_BASE}/admin/decline-cap-request.php?id=${id}`,
  adminSendFeeRequest: `${API_BASE}/admin/send-fee-request.php`,
  adminSendInvoice: `${API_BASE}/admin/send-invoice.php`,
  clock: `${API_BASE}/app/clock.php`,
  employees: `${API_BASE}/app/employees.php`,
  employee: (id) => `${API_BASE}/app/employees.php?id=${id}`,
  wageUnlock: `${API_BASE}/app/wage-unlock.php`,
  attendance: (days) => `${API_BASE}/app/attendance.php?days=${days}`,
  attendancePost: `${API_BASE}/app/attendance.php`,
  attendanceAudit: (id) => `${API_BASE}/app/attendance.php?audit=${id}`,
  attendanceSettings: `${API_BASE}/app/attendance-settings.php`,
  attendancePhoto: (id, which) => `${API_BASE}/app/attendance-photo.php?entry=${id}&which=${which}`,
  attendanceExport: (from, to, layout) => `${API_BASE}/app/attendance-export.php?from=${from}&to=${to}&layout=${layout}`,
  adminAttendanceArchive: (pub, qs = "") => `${API_BASE}/admin/attendance-archive.php?tenant=${pub}${qs}`,
  menuItem: (id) => `${API_BASE}/app/menu-items.php?id=${id}`,
  menuItemImage: `${API_BASE}/app/menu-item-image.php`,
  menuItemImageDelete: (id) => `${API_BASE}/app/menu-item-image.php?id=${id}`,
  menuOptions: `${API_BASE}/app/menu-options.php`,
  menuOptionGroup: (id) => `${API_BASE}/app/menu-options.php?id=${id}`,
  menuOptionsLink: `${API_BASE}/app/menu-options.php?action=link`,
  onlineBranding: `${API_BASE}/app/online-branding.php`,
  onlineBrandingDelete: (kind) => `${API_BASE}/app/online-branding.php?kind=${kind}`,
  onlineImageBase: `${API_BASE}/online/image.php`,
  onlineMenu: (pub) => `${API_BASE}/online/menu.php?tenant=${pub}`,
  onlineSlots: (pub, date) => `${API_BASE}/online/slots.php?tenant=${pub}&date=${date}`,
  onlinePlace: `${API_BASE}/online/place.php`,
  onlineTrack: `${API_BASE}/online/track.php`,
  onlineOrders: `${API_BASE}/app/online-orders.php`,
  onlineOrdersHistory: (q, page = 1, limit = 25) => `${API_BASE}/app/online-orders.php?view=history&q=${encodeURIComponent(q)}&page=${page}&limit=${limit}`,
  onlineOrderAction: `${API_BASE}/app/online-order-action.php`,
  onlineSettings: `${API_BASE}/app/online-settings.php`,
  featureToggles: `${API_BASE}/tenant/tenant-feature-toggles.php`,
  adminStripeSettings: `${API_BASE}/admin/stripe-settings.php`,
  adminInvoices: (view) => `${API_BASE}/admin/invoices.php?view=${view}`,
  adminInvoice: (id) => `${API_BASE}/admin/invoices.php?id=${id}`,
  adminInvoiceMarkPaid: `${API_BASE}/admin/invoice-mark-paid.php`,
  adminInvoiceActivateGrace: `${API_BASE}/admin/invoice-activate-grace.php`,
  adminTenantSubscription: (id) => `${API_BASE}/admin/tenant-subscription.php?id=${id}`,
  adminBulkAutosendInvoice: `${API_BASE}/admin/bulk-autosend-invoice.php`,
  adminDashboardReport: `${API_BASE}/admin/dashboard-report.php`,
  feeAgreement: `${API_BASE}/fee-agreement.php`,
  defaultCaps: `${API_BASE}/default-caps.php`,
  capRequest: `${API_BASE}/app/cap-request.php`,
  contactSupport: `${API_BASE}/app/contact-support.php`,
  health: `${API_BASE}/health.php`,
};
